/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoaTrustCertificatePublicKey
 */
export interface LoaTrustCertificatePublicKey {
    /**
     * 
     * @type {Blob}
     * @memberof LoaTrustCertificatePublicKey
     */
    encoded?: Blob;
    /**
     * 
     * @type {string}
     * @memberof LoaTrustCertificatePublicKey
     */
    algorithm?: string;
    /**
     * 
     * @type {string}
     * @memberof LoaTrustCertificatePublicKey
     */
    format?: string;
}

export function LoaTrustCertificatePublicKeyFromJSON(json: any): LoaTrustCertificatePublicKey {
    return LoaTrustCertificatePublicKeyFromJSONTyped(json, false);
}

export function LoaTrustCertificatePublicKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoaTrustCertificatePublicKey {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'encoded': !exists(json, 'encoded') ? undefined : json['encoded'],
        'algorithm': !exists(json, 'algorithm') ? undefined : json['algorithm'],
        'format': !exists(json, 'format') ? undefined : json['format'],
    };
}

export function LoaTrustCertificatePublicKeyToJSON(value?: LoaTrustCertificatePublicKey | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'encoded': value.encoded,
        'algorithm': value.algorithm,
        'format': value.format,
    };
}

